import React, { useState,useEffect } from 'react';
import { Button, Checkbox, InfoBox, Input, MessageTemplate } from 'components';
import { Modal, Form } from 'antd';

import {getMessageTemplates,deleteMessageTemplate} from 'services/template.service';
import SelectFile from 'components/SelectReadyMesssages/select-file';
import { customMessages } from 'utils';

const MessageTemplateList = (props) => {
  const [messageList, setMessageList] = useState([]);
  const [propMaxCount, setPropMaxCount] = useState(30);

  function onDeleteTemplate(item) {
    deleteMessageTemplate(item).then((res) => {
      onGetMessageTemplates();
    })
    .catch((response) => {
    });
  }

  function onGetMessageTemplates()
  {
    getMessageTemplates().then((res) => {
      setMessageList(res.templates);
      setPropMaxCount(res.maxCount);
    })
    .catch((response) => {
      Modal.error({
        title: 'Hata',
        content: customMessages.getMessage(response.responseCode),
      });
    });
  }

  useEffect(() => {   
    onGetMessageTemplates();
  }, []);

  return (
      <React.Fragment>
           <Form.Item  name="message-list">
                <SelectFile list={messageList}  propCount={propMaxCount} onChange={props.onChange} onDelete={onDeleteTemplate} />
            </Form.Item>
     </React.Fragment>
  )
}

export default MessageTemplateList;